import {Creative} from 'common/src/modules/creatives/creatives.types';
import {setAiCreativesFilter} from 'common/src/modules/creatives/store/creativesLibrary/creativesLibrary.slice';
import {Tool} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';
import {ZodTypeAny} from 'zod';
import {creativesSchema} from '../creativesManagerAgent.consts';
import filterTableTool from 'common/src/modules/shared/copilot/tools/filterTableTool/filterTableTool';

function filterCreativesLibraryTool(store: CLStore): Tool<ZodTypeAny> {
  const tool = filterTableTool({
    displayName: 'Filtering creatives',
    dataTypeSchema: creativesSchema,
    fetchData: () => {
      return store.getState().creativesLibrary.creatives;
    },
    filterFunction: (data: Creative[], query: string) => {
      store.dispatch(
        setAiCreativesFilter({
          aiFilteredIds: data.map((creative) => creative.id),
          query,
        }),
      );
    },
    clearFilter: () => store.dispatch(setAiCreativesFilter({aiFilteredIds: [], query: ''})),
  });

  tool.description = 'Filter creatives in the creatives library and clear filter';

  return tool;
}

export default filterCreativesLibraryTool;
